// extracted by mini-css-extract-plugin
module.exports =  {"fullSize":"application_card_base-module_fullSize_ce294","halfSize":"application_card_base-module_halfSize_fba43"};